import React from "react";
import Tabs from "@material-ui/core/Tabs";

function CustomTabs (props) {
  const {...rest} = props;
  return (<Tabs {...rest}/>)
}

export default CustomTabs;